import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const formatPrice = (value) => {
    const num = Number(value);
    if (isNaN(num) || num <= 0) return 'N/A';

    if (num >= 1e7) {
        return `${(num / 1e7).toFixed(2)} Crore`;
    } else if (num >= 1e5) {
        return `${(num / 1e5).toFixed(2)} Lakh`;
    } else {
        return num.toLocaleString('en-IN'); // fallback for values < 1 Lakh
    }
};

const getPriceAndAreaDetails = (flatTypeArray) => {
    let smallest = null;
    let largest = null;

    flatTypeArray.forEach(ft => {
        if (Array.isArray(ft.builtUpAreas)) {
            ft.builtUpAreas.forEach(area => {
                const price = parseFloat(area.expectedPrice || 0);
                if (!isNaN(price) && price > 0) {
                    if (!smallest || price < parseFloat(smallest.expectedPrice)) smallest = area;
                    if (!largest || price > parseFloat(largest.expectedPrice)) largest = area;
                }
            });
        }
    });

    return { smallest, largest };
};
const HomeCategoryCarousel = () => {
    const [categories, setCategories] = useState([]);
    const [imageIndexes, setImageIndexes] = useState([]);
    const [showScrollLeft, setShowScrollLeft] = useState(false);
    const [showScrollRight, setShowScrollRight] = useState(false);
    const scrollRef = useRef();
    const navigate = useNavigate();

    console.log(categories)
    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await fetch('https://100real.xyz/category/getcategory/HBTR0003');
            let res = await response.json();

            res = res.filter(category => category.status === 'Active');
            // Log count
            console.log('Active Categories Count:', res.length);

            res = res.map(category => {
                let buildings = [];
                try {
                    buildings = JSON.parse(category.buildings || '[]').map(building => ({
                        ...building,
                        amenities: parseArray(building.amenities),
                        flatType: parseArray(building.flatType),
                        formImages: parseArray(building.formImages),
                        locationAdvantages: parseArray(building.locationAdvantage || building.locationAdvantages),
                        security: parseArray(building.security),
                        water_supply: parseArray(building.water_supply),
                    }));
                } catch (err) {
                    console.error('Error parsing buildings:', err);
                }
                return { ...category, buildings };
            });

            setCategories(res);
        } catch (error) {
            console.error('Fetch error:', error);
        }
    };

    const parseArray = (input) => {
        if (Array.isArray(input)) return input;
        if (typeof input === 'string') {
            try {
                return JSON.parse(input);
            } catch {
                return [];
            }
        }
        return [];
    };

    const handlePageChange = (propertyId, propertyType) => {
        if (propertyType === 'Residential') {
            navigate(`/residential-property/${propertyId}`);
        } else if (propertyType === 'Commercial') {
            navigate(`/commercial-property/${propertyId}`);
        } else if (propertyType === 'Rent Residential') {
            navigate(`/rent-property/${propertyId}`);
        }
    };

    const formatCarpetAreas = (flatTypes = []) => {
        const areaSet = new Set();

        flatTypes.forEach(ft => {
            if (Array.isArray(ft.builtUpAreas)) {
                ft.builtUpAreas.forEach(areaObj => {
                    const area = parseFloat(areaObj?.value);
                    if (!isNaN(area)) areaSet.add(area);
                });
            }
        });

        const sortedAreas = [...areaSet].sort((a, b) => a - b);
        const areaString = sortedAreas.length > 0 ? `${sortedAreas.join(', ')} sqft` : '';
        return areaString.length > 20 ? areaString.slice(0, 17) + '...' : areaString;
    };

    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = direction === 'left' ? -300 : 300;
            scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    const updateScrollVisibility = () => {
        const el = scrollRef.current;
        if (el) {
            setShowScrollLeft(el.scrollLeft > 0);
            setShowScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
        }
    };

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        updateScrollVisibility();
        el.addEventListener('scroll', updateScrollVisibility);
        window.addEventListener('resize', updateScrollVisibility);

        return () => {
            el.removeEventListener('scroll', updateScrollVisibility);
            window.removeEventListener('resize', updateScrollVisibility);
        };
    }, [categories]);

    useEffect(() => {
        const allProperties = categories.flatMap(c => c.buildings || []);
        setImageIndexes(new Array(allProperties.length).fill(0));
    }, [categories]);

    useEffect(() => {
        const interval = setInterval(() => {
            setImageIndexes(prev =>
                prev.map((index, idx) => {
                    const category = categories.find(cat => cat.buildings?.[idx]);
                    const imagesLen = category?.buildings?.[idx]?.formImages?.length || 1;
                    return imagesLen > 1 ? (index + 1) % imagesLen : 0;
                })
            );
        }, 3000);
        return () => clearInterval(interval);
    }, [categories]);

    return (
        <>
            {categories.map((category, catIdx) =>
                category.buildings && category.buildings.length > 0 ? (
                    <div className="properties-main-first-brick home-category-main-first-bric" key={catIdx}>
                        <div className="property-section-heading-first-brick">
                            <h1>{category.category}</h1>
                            <p>Browse premium listings across top cities in India.</p>
                        </div>

                        {showScrollLeft && (
                            <button
                                className="property-card-scroll-btn-first-brick property-card-left-first-brick"
                                onClick={() => scroll('left')}
                            >
                                <i className="fa-solid fa-chevron-left"></i>
                            </button>
                        )}

                        <div className="property-cards-first-brick" ref={scrollRef}>
                            {category.buildings.map((property, idx) => {
                                const { smallest, largest } = getPriceAndAreaDetails(property.flatType || []);
                                const images = property.formImages?.slice(0, 3) || [];
                                const isSlider = images.length > 1;

                                return (
                                    <div className="property-card-first-brick" key={property.property_id || idx}
                                        onClick={() => handlePageChange(property.property_id, property.typeofproperty)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="ribbon">
                                            {property.typeofproperty?.charAt(0).toUpperCase() +
                                                property.typeofproperty?.slice(1).toLowerCase() || 'Property'}
                                        </div>

                                        <div className="property-card-images-first-brick">
                                            {isSlider ? (
                                                <>
                                                    {images.map((img, i) => (
                                                        <img
                                                            key={i}
                                                            src={`https://100real.xyz/Images/Store/${img}`}
                                                            alt={`${property.building_name} view ${i + 1}`}
                                                            style={{
                                                                opacity: i === 0 ? 1 : 0,
                                                                transition: 'opacity 0.6s ease-in-out',
                                                                zIndex: i === 0 ? 2 : 1,
                                                                position: 'absolute',
                                                            }}
                                                        />
                                                    ))}
                                                </>
                                            ) : (
                                                <img
                                                    src={`https://100real.xyz/Images/Store/${images[0]}`}
                                                    alt={property.building_name}
                                                    style={{
                                                        opacity: 1,
                                                        zIndex: 2,
                                                        position: 'absolute',
                                                    }}
                                                />
                                            )}
                                        </div>

                                        <div className="property-card-content-first-brick">
                                            <div
                                                className="property-card-building-name-first-brick"
                                                onClick={() =>
                                                    handlePageChange(property.property_id, property.typeofproperty)
                                                }
                                            >
                                                <h1>{property.building_name}</h1>
                                            </div>

                                            {(smallest?.expectedPrice > 0 || largest?.expectedPrice > 0) && (
                                                <div className="property-card-pricing-first-brick">
                                                    <h3>
                                                        {smallest?.expectedPrice > 0 && largest?.expectedPrice > 0 ? (
                                                            smallest.expectedPrice === largest.expectedPrice ? (
                                                                `₹ ${formatPrice(smallest.expectedPrice)}`
                                                            ) : (
                                                                `₹ ${formatPrice(smallest.expectedPrice)} - ₹ ${formatPrice(largest.expectedPrice)}`
                                                            )
                                                        ) : smallest?.expectedPrice > 0 ? (
                                                            `₹ ${formatPrice(smallest.expectedPrice)}`
                                                        ) : (
                                                            `₹ ${formatPrice(largest.expectedPrice)}`
                                                        )}
                                                    </h3>
                                                </div>
                                            )}

                                            <div className="property-card-carpet-address-first-brick">
                                                <p>{formatCarpetAreas(property.flatType)} at {property.city}</p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {showScrollRight && (
                            <button
                                className="property-card-scroll-btn-first-brick property-card-right-first-brick"
                                onClick={() => scroll('right')}
                            >
                                <i className="fa-solid fa-chevron-right"></i>
                            </button>
                        )}
                    </div>
                ) : null
            )}
        </>
    );
};

export default HomeCategoryCarousel;
